import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { usePopoverOnInteraction } from '../../hooks/usePopoverOnInteraction';
import PopperPositionedPopover from '../../PopperPositionedPopover';
import DefaultPopoverContent from '../../_partials/DefaultPopoverContent';
/** Please note that this component is not DS-conforming */ const SimpleHoverPopperPopover = ({ children, popoverContent, positionFixed, eventsEnabled, referenceElement, hoverDelay, placement, secondaryPlacement, showArrow = true, className, arrowClassName, contentClassName, wrapperClassName, noPadding, forceTheme, isVisible: isVisibleProp = true, onVisible })=>{
    const isMobile = useContext(MobileContext);
    const complete_theme = useFlag('complete_theme');
    const { isVisible, onClick, onMouseEnter, onMouseLeave } = usePopoverOnInteraction({
        listenOnHover: !isMobile,
        hoverDelay,
        onVisible
    });
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        usePortal: true,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        isVisible: isVisibleProp && isVisible,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        referenceElement: referenceElement,
        className: className,
        renderPopover: ({ effectivePlacement, effectiveSecondaryPlacement, contentStyle, arrowStyle, contentAttributes, arrowAttributes, rootRef, arrowRef, updatePositioning })=>{
            const content = /*#__PURE__*/ React.createElement(DefaultPopoverContent, {
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                contentStyle: contentStyle,
                arrowStyle: arrowStyle,
                contentAttributes: contentAttributes,
                arrowAttributes: arrowAttributes,
                updatePositioning: updatePositioning,
                showArrow: showArrow,
                contentClassName: contentClassName,
                arrowClassName: arrowClassName,
                wrapperClassName: wrapperClassName,
                noPadding: noPadding,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, popoverContent);
            return forceTheme && !complete_theme ? /*#__PURE__*/ React.createElement(ThemeOverride, {
                theme: forceTheme
            }, content) : content;
        },
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave
    }, children);
};
SimpleHoverPopperPopover.displayName = 'SimpleHoverPopperPopover';
export default SimpleHoverPopperPopover;
